/**
 * useSearch -- Extract the search/query string from the hash URL.
 *
 * For a hash like `#/path?foo=bar`, returns `"?foo=bar"`.
 * Returns `""` if no query string is present.
 */
import { useState, useEffect } from "react";

function getHashSearch(): string {
  const hash = window.location.hash;
  const idx = hash.indexOf("?");
  return idx >= 0 ? hash.slice(idx) : "";
}

export function useSearch(): string {
  const [search, setSearch] = useState(getHashSearch);

  useEffect(() => {
    const handler = () => setSearch(getHashSearch());
    window.addEventListener("hashchange", handler);
    return () => window.removeEventListener("hashchange", handler);
  }, []);

  return search;
}
